<template>
  <div>
    <view-video-modal ref="view-video-modal" />
    <b-card class="box-list-question" style="max-width: 100%">
      <b-container>
        <b-row> <h3 class="missions-title">Misiones disponibles!</h3> </b-row>
        <b-row v-if="loading">
          <b-col class="text-center"><b-spinner variant="primary" /></b-col>
        </b-row>
        <b-row v-else-if="!missions.length">
          <b-col class="text-center">No hay misiones disponibles!</b-col>
        </b-row>
        <b-row v-else>
          <b-col class="mx-0 px-0">
            <ol class="custom-list">
              <li
                v-for="(mission, mIndex) in missions"
                :key="'mission-' + mIndex"
              >
                <b-container>
                  <b-row>
                    <b-col>
                      <h5>{{ mission.mission.title }}</h5>
                      {{ mission.mission.description }}
                      <b-container
                        v-if="mission.mission.special_rewards.length"
                        class="reward-container"
                      >
                        <h6 class="reward-title">Recompensas</h6>
                        <ul>
                          <li
                            v-for="(reward, rIndex) in mission.mission
                              .special_rewards"
                            :key="mIndex + '-' + rIndex"
                          >
                            {{ reward.name }}: {{ reward.uses }}
                          </li>
                        </ul>
                      </b-container>
                    </b-col>
                    <b-col class="text-right" cols="5" lg="3">
                      <div v-if="!mission.completed">
                        <b-container>
                          <b-row v-if="mission.mission.route">
                            <b-button
                              variant="outline-primary"
                              class="font-weight-bold text-black"
                              block
                              @click="goToLink(mission.mission.route)"
                            >
                              Ir!
                            </b-button>
                          </b-row>
                          <b-row v-if="mission.mission.video">
                            <b-button
                              variant="outline-primary"
                              class="font-weight-bold text-black"
                              block
                              @click="
                                $refs['view-video-modal'].open(
                                  mission.mission.video
                                )
                              "
                            >
                              Ver tutorial!
                            </b-button>
                          </b-row>
                          <div
                            v-if="mission.mission.is_code && !mission.completed"
                            class="d-block d-lg-none"
                          >
                            <b-row>
                              <b-form-input
                                v-model="mission.mission.code"
                                placeholder="Código..."
                                style="width: 75px"
                              />
                            </b-row>
                            <b-row>
                              <b-button
                                variant="primary"
                                pill
                                block
                                size="sm"
                                @click="
                                  redeemPromotionalCode(
                                    mission.mission.code,
                                    mission
                                  )
                                "
                              >
                                <v-icon name="plus" />
                              </b-button>
                            </b-row>
                          </div>
                        </b-container>
                      </div>
                      <div v-else>
                        <b-button variant="primary" block disabled>
                          <v-icon name="check"> </v-icon>
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      v-if="mission.mission.is_code && !mission.completed"
                      cols="5"
                      lg="3"
                      class="d-none d-lg-block"
                    >
                      <b-form inline>
                        <b-form-input
                          v-model="mission.mission.code"
                          placeholder="Código..."
                          class="mr-2"
                          style="width: 120px"
                        />
                        <b-button
                          variant="primary"
                          pill
                          size="sm"
                          @click="
                            redeemPromotionalCode(mission.mission.code, mission)
                          "
                        >
                          <v-icon name="plus" />
                        </b-button>
                      </b-form>
                    </b-col>
                  </b-row>
                </b-container>
              </li>
            </ol>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>
<script>
import missionService from "@/services/missionService";
import userService from "@/services/userService";
import ViewVideoModal from "../modals/ViewVideoModal";

export default {
  components: {
    ViewVideoModal,
  },
  props: {
    // `context.service` es la etiqueta del chatbot ("Eureka",
    // "Planificaciones", ...), la misma que el titulo del Service en la BD.
    context: {
      type: Object,
      required: false,
    },
  },
  created() {
    // Se filtra por el servicio del chatbot que abre la vista: el backend
    // devuelve las misiones generales mas las de ese servicio, y aca se
    // muestran en una sola lista (sin separarlas por seccion).
    // ponytail: la misión de completar perfil está oculta por ahora; sólo
    // quedan las misiones que vienen del backend.
    this.getMissions(this.context ? this.context.service : "");
  },
  data() {
    return {
      missions: [],
      loading: false,
    };
  },
  methods: {
    goToLink(url) {
      // window.location.href = url;
      window.open(url, "_blank");
    },
    getMissions(service) {
      this.loading = true;
      missionService.getMissions(service).then((data) => {
        this.missions = data;
        this.loading = false;
      });
    },
    redeemPromotionalCode(code, mission) {
      userService.redeemPromotionalCode({ code: code }).then(
        (data) => {
          this.$toasted.success(data.message);
          mission.completed = true;
        },
        (error) => {
          this.$toasted.error(
            error.response.data.message || "Error al canjear código"
          );
        }
      );
    },
  },
};
</script>
<style lang="scss">
.missions-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 28px;
  text-align: left;
  position: relative;
}

.missions-title::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #738cf2, #f2c958);
  border-radius: 2px;
}
.box-list-question {
  // float: right;
  background-color: white !important;
  color: rgb(0, 0, 0) !important;
  border: 2pt dashed var(--main-color) !important;
  border-radius: 15px !important;
  font-family: "Ubuntu" !important;
}
.custom-list {
  list-style: none;
  padding: 0;
  counter-reset: list-counter;
}

.custom-list > li {
  position: relative;
  padding-top: 1rem;
  padding-left: 2.5rem;
  margin-bottom: 1rem;
  counter-increment: list-counter;
  border: 2pt dashed #ebedec !important;
  border-radius: 15px !important;
  background-color: #fafbfc;
}

.custom-list > li::before {
  content: counter(list-counter);
  position: absolute;
  left: 5px;
  top: 1rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #5c6fd6; /* azul */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-family: sans-serif;
}

.reward-container {
  margin-top: 1rem;
  border: 2pt dashed #f6f5f3 !important;
  border-radius: 15px !important;
  background-color: #f6f5f3 !important;

  .reward-title {
    font-size: 20px;
    font-weight: 700;
    color: #7786dd;
  }
}
</style>
